module.exports = __webpack_public_path__ + "static/img/index-menu-1.db5dcdc2.png";